import React from 'react'
import gql from 'graphql-tag'
import { Mutation } from 'react-apollo'
import { AttestationReportRequest } from './index'

export const generateAttestationReportMutation = gql`
  mutation GenerateAttestationReport(
    $organizationID: ID!
    $applicationID: ID!
    $request: AttestationReportRequestInput!
  ) {
    generateAttestationReport(
      input: {
        organizationID: $organizationID
        applicationID: $applicationID
        request: $request
      }
    ) {
      _placeholder
    }
  }
`

interface MutationResponse {
  readonly _placeholder: boolean
}

interface MutationVars {
  readonly organizationID: string
  readonly applicationID: string
  readonly request: AttestationReportRequest
}

interface GenerateAttestationReportMutationProps {
  readonly children: (props: {
    readonly generateAttestationReport: (args: MutationVars) => Promise<any>
  }) => React.ReactNode
}

export function GenerateAttestationReportMutation({
  children
}: GenerateAttestationReportMutationProps) {
  return (
    <Mutation<MutationResponse, MutationVars>
      mutation={generateAttestationReportMutation}
    >
      {(generateAttestationReport) =>
        children({
          generateAttestationReport: (args) => {
            return generateAttestationReport({ variables: args })
          }
        })
      }
    </Mutation>
  )
}
